import React, { useState } from "react";
import "./ChatPage.scss";
import { Button } from "antd";
import { postMustardBotChat } from "services/SauceService";

interface Message {
  role: "user" | "assistant";
  content: string;
}

const ChatPage: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const handleSend = async () => {
    if (!input.trim()) return;
    const userMessage: Message = { role: "user", content: input };
    const newHistory = [...messages, userMessage];
    setMessages(newHistory);
    setInput("");
    setLoading(true);
    try {
      const response = await postMustardBotChat({
        message: input,
        conversationHistory: newHistory,
      });
      console.log(response);
      const assistantContent = response?.data?.message || "(No response)";
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: assistantContent },
      ]);
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: "Sorry, something went wrong." },
      ]);
    }
    setLoading(false);
  };

  return (
    <div className="chat-page">
      <div className="chat-messages">
        {messages.map((msg, idx) => (
          <div key={idx} className={`chat-message ${msg.role}`}>
            <div className="chat-bubble">{msg.content}</div>
          </div>
        ))}
      </div>
      <div className="chat-input-container">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => !loading && e.key === "Enter" && handleSend()}
          placeholder="Type your message..."
          className="chat-input"
          disabled={loading}
        />
        <Button
          onClick={handleSend}
          type="primary"
          className="send-btn"
          disabled={loading || !input.trim()}
        >
          {loading ? "Sending..." : "Send"}
        </Button>
      </div>
    </div>
  );
};

export default ChatPage;
